var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyPlanSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9294_336988)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 21H19.5156C20.0972 21 20.5703 20.5269 20.5703 19.9453V12.5156H18.1094C17.5278 12.5156 17.0547 12.0425 17.0547 11.4609V9H12.4844C11.9028 9 11.4297 9.47311 11.4297 10.0547V19.9453C11.4297 20.5269 11.9028 21 12.4844 21ZM13.8906 13.9453H18.1094C18.3037 13.9453 18.4609 14.1026 18.4609 14.2969C18.4609 14.4912 18.3037 14.6484 18.1094 14.6484H13.8906C13.6963 14.6484 13.5391 14.4912 13.5391 14.2969C13.5391 14.1026 13.6963 13.9453 13.8906 13.9453ZM13.8906 15.3516H18.1094C18.3037 15.3516 18.4609 15.5088 18.4609 15.7031C18.4609 15.8974 18.3037 16.0547 18.1094 16.0547H13.8906C13.6963 16.0547 13.5391 15.8974 13.5391 15.7031C13.5391 15.5088 13.6963 15.3516 13.8906 15.3516ZM13.8906 16.7578H18.1094C18.3037 16.7578 18.4609 16.9151 18.4609 17.1094C18.4609 17.3037 18.3037 17.4609 18.1094 17.4609H13.8906C13.6963 17.4609 13.5391 17.3037 13.5391 17.1094C13.5391 16.9151 13.6963 16.7578 13.8906 16.7578ZM13.8906 18.1641H16.7031C16.8974 18.1641 17.0547 18.3213 17.0547 18.5156C17.0547 18.7099 16.8974 18.8672 16.7031 18.8672H13.8906C13.6963 18.8672 13.5391 18.7099 13.5391 18.5156C13.5391 18.3213 13.6963 18.1641 13.8906 18.1641Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 11.8096H20.3643L17.7578 9.20312V11.4581C17.7578 11.652 17.9154 11.8096 18.1094 11.8096Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9294_336988",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9294_336988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9294_336988",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyPlanSvg);
export default __webpack_public_path__ + "static/media/study-plan-svg.b856823580711cd13306f11c4f9d52c5.svg";
export { ForwardRef as ReactComponent };